"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(a) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _antd = require("antd"),
    _Button = _interopRequireDefault(require("../Button")),
    S = _interopRequireWildcard(require("./styles"));

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var a = new WeakMap();
  return _getRequireWildcardCache = function _getRequireWildcardCache() {
    return a;
  }, a;
}

function _interopRequireWildcard(a) {
  if (a && a.__esModule) return a;
  if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
    "default": a
  };

  var b = _getRequireWildcardCache();

  if (b && b.has(a)) return b.get(a);
  var c = {},
      d = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var e in a) {
    if (Object.prototype.hasOwnProperty.call(a, e)) {
      var f = d ? Object.getOwnPropertyDescriptor(a, e) : null;
      f && (f.get || f.set) ? Object.defineProperty(c, e, f) : c[e] = a[e];
    }
  }

  return c["default"] = a, b && b.set(a, c), c;
}

function _slicedToArray(a, b) {
  return _arrayWithHoles(a) || _iterableToArrayLimit(a, b) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(a, b) {
  if (Symbol.iterator in Object(a) || "[object Arguments]" === Object.prototype.toString.call(a)) {
    var c = [],
        d = !0,
        e = !1,
        f = void 0;

    try {
      for (var g, h = a[Symbol.iterator](); !(d = (g = h.next()).done) && (c.push(g.value), !(b && c.length === b)); d = !0) {
        ;
      }
    } catch (a) {
      e = !0, f = a;
    } finally {
      try {
        d || null == h["return"] || h["return"]();
      } finally {
        if (e) throw f;
      }
    }

    return c;
  }
}

function _arrayWithHoles(a) {
  if (Array.isArray(a)) return a;
}

var menu = function menu(a) {
  var b = a.items,
      c = a.onClick;
  return _react["default"].createElement(_antd.Menu, {
    onClick: c
  }, b && 0 < b.length && b.map(function (a, b) {
    var c = a.icon,
        d = a.content;
    return (// eslint-disable-next-line react/no-array-index-key
      _react["default"].createElement(_antd.Menu.Item, {
        key: "".concat(d, "_").concat(b)
      }, _react["default"].createElement(_antd.Icon, {
        type: c
      }), d)
    );
  }));
},
    _default = function _default(a) {
  var b = a.items,
      c = a.label,
      d = a.color,
      e = a.size,
      f = a.onClick,
      g = (0, _react.useState)(null),
      h = _slicedToArray(g, 2),
      i = h[0],
      j = h[1];

  return _react["default"].createElement(_antd.Dropdown, {
    overlay: menu({
      items: b,
      onClick: f
    }),
    onVisibleChange: function onVisibleChange(a) {
      return j(a);
    },
    visible: i,
    trigger: ["click"]
  }, _react["default"].createElement(S.ButtonWrapper, null, _react["default"].createElement(_Button["default"], {
    size: e,
    color: d,
    icon: "down"
  }, c)));
};

exports["default"] = _default;